import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SlitValveSealComponent } from './slit-valve-seal.component';

const routes: Routes = [
  {
    path: '',
    component: SlitValveSealComponent,
    data: {
      meta: {
        title: 'Applied Materials and Bonded Slit Valve Door Seal Solution',
        description: 'Applied Materials P-5000 Slit Valve Door Seal Solution from Marco Rubber',
        keywords: ''
      }
    }
  }
];
export const routerModuleForChild = RouterModule.forChild(routes)

@NgModule({
  imports: [routerModuleForChild],
  exports: [RouterModule]
})
export class SlitValveSealRoutingModule { }
